function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "fb_logo",
  fill: "#FFFFFF"
}, React.createElement("path", {
  d: "M18.8958333,0 L1.11111111,0 C0.497461389,-3.75752084e-17 7.51504168e-17,0.497461389 0,1.11111111 L0,18.9027778 C0.00760332867,19.5109967 0.502844671,20.0000475 1.11111111,20 L10.6944444,20 L10.6944444,12.2652778 L8.08611111,12.2652778 L8.08611111,9.23888889 L10.6833333,9.23888889 L10.6833333,7.01666667 C10.6833333,4.43333333 12.2611111,3.02638889 14.5722222,3.02638889 C15.3502181,3.02328912 16.1277914,3.06316467 16.9013889,3.14583333 L16.9013889,5.84027778 L15.3,5.84027778 C14.05,5.84027778 13.8083333,6.43611111 13.8083333,7.30972222 L13.8083333,9.23888889 L16.8055556,9.23888889 L16.4166667,12.2652778 L13.8083333,12.2652778 L13.8083333,20 L18.8958333,20 C19.5040711,19.9962102 19.9962102,19.5040711 20,18.8958333 L20,1.11111111 C20.0000119,0.500163165 19.5067693,0.00381842455 18.8958333,0 Z",
  id: "Path"
})));

var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    className: "fb-logo",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/facebook.217356c1.svg";
export { ForwardRef as ReactComponent };